module.exports = __webpack_public_path__ + "img/35.ae665a15.jpg";